import { type ExportFormatType } from '@/components/modals/ReportSummaryModal/ReportSummaryModal'
import { EmailReportsActionsHeapEvents } from '@/heap/heapEvents'
import { trackHeapEvent } from '@/heap/trackHeapEvent'
import { ReportDataType } from '@/services/types/notifications/mockNotifications'

export interface EmailReportsTrackingDataProps {
  emailReportId?: string
  status: 'success' | 'error'
}

interface ExportCommonProps {
  page: ReportDataType.analytics | ReportDataType.reviewAnalysis
}

interface ExportActionProps extends ExportCommonProps {
  locationsCount: string
  foldersCount: string
  publishers: string
  reportType: ExportFormatType[]
}

export const emailReportsTrackingEvents = {
  create({ status, emailReportId }: EmailReportsTrackingDataProps) {
    const actionType = 'create'
    trackHeapEvent(EmailReportsActionsHeapEvents.save, {
      emailReportId,
      status,
      actionType,
    })
  },

  edit({ status, emailReportId }: EmailReportsTrackingDataProps) {
    const actionType = 'edit'
    trackHeapEvent(EmailReportsActionsHeapEvents.save, {
      emailReportId,
      status,
      actionType,
    })
  },

  delete({ status, emailReportId }: EmailReportsTrackingDataProps) {
    const actionType = 'delete'
    trackHeapEvent(EmailReportsActionsHeapEvents.delete, {
      emailReportId,
      status,
      actionType,
    })
  },

  exportClick({ page }: ExportCommonProps) {
    const events = {
      [ReportDataType.analytics]: EmailReportsActionsHeapEvents.exportAnalyticsClick,
      [ReportDataType.reviewAnalysis]: EmailReportsActionsHeapEvents.exportReviewAnalysisClick,
    }
    trackHeapEvent(events[page], {})
  },

  exportAction(data: ExportActionProps) {
    const events = {
      [ReportDataType.analytics]: EmailReportsActionsHeapEvents.exportAnalyticsAction,
      [ReportDataType.reviewAnalysis]: EmailReportsActionsHeapEvents.exportReviewAnalysisAction,
    }
    const reportType = data.reportType.length === 1 ? data.reportType.join() : 'both'

    trackHeapEvent(events[data.page], {
      ...data,
      reportType,
    })
  },
}
